import {useEffect, useRef, useState} from 'react'
import {publish, subscribe, unsubscribe} from '@/script/event.mjs'

export default () => {
    const refEditingNode = useRef()

    const extensions = () => ({
        endEditNodeComment(node) {
            if (! this.isNodeEditingComment(node)) {
                return
            }

            refEditingNode.current = null
            publish(node, 'edit_comment_end')
        },

        isNodeEditingComment(node) {
            return refEditingNode.current === node
        },

        startEditNodeComment(node) {
            if (this.isNodeEditingComment(node)) {
                return
            }

            refEditingNode.current = node
            publish(node, 'edit_comment_start')
        },

        useCommentedNodes() {
            const [nodes, setNodes] = useState(() => {
                const map = this

                const iterCommented = function* () {
                    for (const node of map.dfs(map.root)) {
                        if (node.comment) {
                            yield node
                        }
                    }
                }

                return new Set(iterCommented())
            })

            useEffect(
                () => {
                    const handleModelChange = changes => {
                        const newNodes = new Set(nodes)

                        for (const [node, change] of changes) {
                            if (nodes.has(node)) {
                                if (
                                    ! node.comment ||
                                    change.has('isDeleted')
                                ) {
                                    newNodes.delete(node)
                                }
                            }
                            else {
                                if (node.comment) {
                                    newNodes.add(node)
                                }
                            }
                        }

                        setNodes(newNodes)
                    }

                    subscribe(this, 'model_change', handleModelChange)

                    return () => {
                        unsubscribe(this, 'model_change', handleModelChange)
                    }
                },

                []
            )

            return nodes
        },

        useIsEditingComment(node) {
            const [isEditing, setIsEditing] = useState(
                refEditingNode.current === node
            )

            useEffect(
                () => {
                    const handleEditEnd = () => setIsEditing(false)
                    const handleEditStart = () => setIsEditing(true)
                    subscribe(node, 'edit_comment_end', handleEditEnd)
                    subscribe(node, 'edit_comment_start', handleEditStart)

                    return () => {
                        unsubscribe(node, 'edit_comment_end', handleEditEnd)
                        unsubscribe(node, 'edit_comment_start', handleEditStart)
                    }
                },

                [node]
            )

            return isEditing
        },
    })

    const watchers = {
        edit_node_comment(node) {
            publish(refEditingNode.current, 'edit_comment_end')
            refEditingNode.current = node
            publish(node, 'edit_comment_start')
        },
    }

    return {extensions, watchers}
}
